// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* color */
  --background-black: #2c2c2c;
  --background-main: #f4f3ef;
  --light-black: #66615b;
  --box-black: #444;
  --box-light-grey: rgba(0, 0, 0, 0.12);
  --grid-grey: #ddd;

  /* size */
  --border-radius: 10px;

  /* 전역 스타일 관련 */
  --menu-width: 20vw;
  --menu-width-minus: -20vw;
  --header-height: 8vh;

  /* 다크모드 관련 컬러 */
  --mode-white: #ffffff;
  --mode-95: #eceff1;
  --mode-90: #cfd8dc;
  --mode-80: #b0bec5;
  --mode-70: #90a4ae;
  --mode-30: #455a64;
  --mode-20: #37474f;
  --mode-10: #263238;
  --mode-black: #222222;

  --error-color: #bf0000;
  --interactive-color: #0071bc;

  /* 폰트 사이즈 반응형 rem*/
  --font-10px: 0.625rem;
  --font-12px: 0.75rem;
  --font-14px: 0.875rem;
  --font-16px: 1rem;
  --font-18px: 1.125rem;
  --font-20px: 1.25rem;
  --font-22px: 1.375rem;
  --font-24px: 1.5rem;
  --font-28px: 1.75rem;
}

.bold {
  font-weight: 700;
}
.font20 {
  font-size: 20px;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

@font-face {
  font-family: "Pretendard-Regular";
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff")
    format("woff");
  font-weight: 400;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;;EAEjB,SAAS;EACT,qBAAqB;;EAErB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;;EAEpB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;;EAErB,sBAAsB;EACtB,4BAA4B;;EAE5B,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC;kBACgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[":root {\n  /* color */\n  --background-black: #2c2c2c;\n  --background-main: #f4f3ef;\n  --light-black: #66615b;\n  --box-black: #444;\n  --box-light-grey: rgba(0, 0, 0, 0.12);\n  --grid-grey: #ddd;\n\n  /* size */\n  --border-radius: 10px;\n\n  /* 전역 스타일 관련 */\n  --menu-width: 20vw;\n  --menu-width-minus: -20vw;\n  --header-height: 8vh;\n\n  /* 다크모드 관련 컬러 */\n  --mode-white: #ffffff;\n  --mode-95: #eceff1;\n  --mode-90: #cfd8dc;\n  --mode-80: #b0bec5;\n  --mode-70: #90a4ae;\n  --mode-30: #455a64;\n  --mode-20: #37474f;\n  --mode-10: #263238;\n  --mode-black: #222222;\n\n  --error-color: #bf0000;\n  --interactive-color: #0071bc;\n\n  /* 폰트 사이즈 반응형 rem*/\n  --font-10px: 0.625rem;\n  --font-12px: 0.75rem;\n  --font-14px: 0.875rem;\n  --font-16px: 1rem;\n  --font-18px: 1.125rem;\n  --font-20px: 1.25rem;\n  --font-22px: 1.375rem;\n  --font-24px: 1.5rem;\n  --font-28px: 1.75rem;\n}\n\n.bold {\n  font-weight: 700;\n}\n.font20 {\n  font-size: 20px;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n@font-face {\n  font-family: \"Pretendard-Regular\";\n  src: url(\"https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff\")\n    format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
